import React, {useState} from 'react'
import {AutoComplete, Button, DatePicker, Form, Modal, Input, Select} from "antd";
import {getAppointmentById, updateAppointment} from "../../services/serviceAppointment";
import {getAllCustomer} from "../../services/serviceCustomer";
import moment from "moment";
import {getRelevantPersonByCustomer} from "../../services/serviceRelevantPerson";
import {exitLoadingState, enterLoadingState} from "../../utils/helpers/commonFunctions";
import { getBrandsAsSelect } from '../../services/serviceBrand';


const {TextArea} = Input
const {Option} = AutoComplete
const dateFormat = 'DD/MM/YYYY HH:mm'
const formLayout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16}
}
const statuses = [
    {
        value: "WAITING",
        text: "BEKLEMEDE"
    },
    {
        value: "NEGATIVE",
        text: "OLUMSUZ"
    },
    {
        value: "POSITIVE",
        text: "OLUMLU"
    }
]

const AppointmentEdit = ({appointment, updater}) => {
    const [form] = Form.useForm();
    const [editModal, setEditModal] = useState(false);
    const [customers, setCustomers] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState();
    const [representatives, setRepresentatives] = useState([]);
    const [selectedRepresentative, setSelectedRepresentative] = useState();
    const [, setDef] = useState('');
    const [loadings, setLoadings] = useState([]);
    const [brands, setBrands] = useState([]);


    const handleEditClick = () => {
        getAppointmentById(appointment.id)
            .then(({data}) => {
                form.setFieldsValue({
                    appointmentCustomer: data.customer.name,
                    appointmentRelevant: `${data.relevantPerson.name} ${data.relevantPerson.surname}`,
                    appointmentTitle: data.title,
                    appointmentStatus: handleDataStatusLanguage(data.status),
                    appointmentResult: data.resultText,
                    appointmentDate: moment(data.planningDate, "YYYY/MM/DD HH:mm"),
                    appointmentBrand: data.brand ? {value: data.brand.id, label: data.brand.code} : null

                })
                setSelectedRepresentative(data.relevantPerson.id)
                setSelectedCustomer(data.customer.id)
                setDef(data.planningDate)
                handleCustomerFocus()
                handleEmployeeFocus(data.customer.id)
                setEditModal(!editModal)
            })
    }
    const handleDataStatusLanguage = (status) => {
        let correctStatus = ''
        statuses.forEach(item => {
            if (status === item.value)
                correctStatus = item.text
        })
        return correctStatus
    }
    const statusChanged = (status) => {
        let changedStatus = ''
        statuses.forEach(item => {
            if (status === item.text)
                changedStatus = item.value
        })
        return changedStatus
    }
    const handleSubmit = () => {
        enterLoadingState(setLoadings)

        const {
            appointmentStatus,
            appointmentResult,
            appointmentTitle,
            appointmentDate,
            appointmentBrand
        } = form.getFieldsValue()

        const status = statusChanged(appointmentStatus);
        const requestObj = {
            relevantPerson: selectedRepresentative? {id: selectedRepresentative} : null,
            customer: selectedCustomer ? {id: selectedCustomer} : null,
            resultText: appointmentResult,
            status: status,
            title: appointmentTitle,
            planningDate: appointmentDate._d ? moment(appointmentDate._d ).format(('YYYY-MM-DDTHH:mm:ss')) : null,
            id: appointment.id,
            brand: appointmentBrand ? {id: appointmentBrand.value || appointmentBrand} : null
        };

        updateAppointment(requestObj)
            .then(() => {
                exitLoadingState(setLoadings)
                setEditModal(!editModal)
                updater()
            })
            .catch(() => exitLoadingState(setLoadings))
    };

    const handleEmployeeFocus = (customerId) => {
        if (customerId){
            getRelevantPersonByCustomer(customerId)
                .then(({data}) => {
                    let employeeData = []
                    data.forEach(item => {
                        let pushObj = {
                            value: item.id,
                            text: `${item.name} ${item.surname}`
                        }
                        employeeData.push(pushObj)
                    })
                    setRepresentatives(employeeData)
                })
        }
    };

    const handleBrandFocus = () => {
        if(!brands.length) {
            getBrandsAsSelect()
            .then(({data}) => {
                const structured = data.map((brand) => {
                    return {value: brand.key, label: brand.label}
                })
                setBrands(structured);
            })
        }
    };

    const handleCustomerFocus = () => {
        getAllCustomer()
            .then(({data}) => {
                let customerData = []
                data.forEach(item => {
                    let pushObj = {
                        value: item.id,
                        text: item.name
                    }
                    customerData.push(pushObj)
                })
                setCustomers(customerData)
            })
    };
    const handleRepresentativeChange = (v, {key}) => setSelectedRepresentative(key);
    const handleCustomerChange = (v, {key}) => {
        if (key){
            setSelectedCustomer(key)
            getRelevantPersonByCustomer(key)
                .then(({data}) => {
                    let employeeData = []
                    data.forEach(item => {
                        let pushObj = {
                            value: item.id,
                            text: item.name
                        }
                        employeeData.push(pushObj)
                    })
                    setRepresentatives(employeeData)
                })
        }
    };

    return (
        <React.Fragment>
            <Button
                key={'editBtn'}
                type={"link"}
                onClick={() => handleEditClick()}
            >Güncelle</Button>

            <Modal
                title={'Güncelle'}
                open={editModal}
                onCancel={() => setEditModal(!editModal)}
                footer={[
                    <Button
                        type={'primary'}
                        key={'SubmitButton'}
                        loading={loadings[0]}
                        onClick={() => form.submit()}
                    >
                        Kaydet
                    </Button>,
                    <Button
                        onClick={() => setEditModal(!editModal)}
                        key={'CancelButton'}
                    >
                        Kapat
                    </Button>
                ]}
            >
                <Form
                    form={form}
                    onFinish={handleSubmit}
                    {...formLayout}
                >
                    <Form.Item
                        label={'Müşteri'}
                        name={'appointmentCustomer'}
                        rules={[
                            {required: true, message: 'Bu alan boş bırakılamaz'},
                            () => ({
                                validator(rule, value) {
                                    let hasValue = customers.filter(customer => customer.text.toLowerCase() === value.toLowerCase())
                                    if (value && hasValue.length > 0) {
                                        handleCustomerChange(true, {key: hasValue[0].value})
                                        return Promise.resolve();
                                    }

                                    return Promise.reject('Lütfen Bir Değer Seçiniz');
                                },
                            })
                        ]}
                    >
                        <AutoComplete
                            filterOption={(inputValue, option) =>
                                option.value.toLocaleUpperCase().indexOf(inputValue.toLocaleUpperCase()) !== -1
                            }
                        >
                            {customers.map(({value, text}) => (
                                <Option key={value} value={text}>{text}</Option>
                            ))}
                        </AutoComplete>

                    </Form.Item>
                    <Form.Item
                        label={'Marka'}
                        name={'appointmentBrand'}
                    >
                        <Select showSearch options={brands}  onFocus={handleBrandFocus} allowClear/>
                    </Form.Item>
                    <Form.Item
                        label={'Konu'}
                        name={'appointmentTitle'}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'İlgili'}
                        name={'appointmentRelevant'}
                        rules={[
                            {required: true, message: 'Bu alan boş bırakılamaz'},
                            () => ({
                                validator(rule, value) {
                                    let hasValue = representatives.filter(rep => rep.text.toLowerCase() === value.toLowerCase())
                                    if (value && hasValue.length > 0) {
                                        handleRepresentativeChange(true, {key: hasValue[0].value})
                                        return Promise.resolve();
                                    }

                                    return Promise.reject('Lütfen Bir Değer Seçiniz');
                                },
                            })
                        ]}
                    >
                        <AutoComplete
                            filterOption={(inputValue, option) =>
                                option.value.toLocaleUpperCase().indexOf(inputValue.toLocaleUpperCase()) !== -1
                            }
                        >
                            {representatives.map(({value, text}) => (
                                <Option key={value} value={text}>{text}</Option>
                            ))}
                        </AutoComplete>
                    </Form.Item>
                    <Form.Item
                        label={'Sonuç Raporu'}
                        name={'appointmentResult'}
                    >
                        <TextArea rows={6}/>
                    </Form.Item>
                    <Form.Item
                        label={'Randevu Tarihi'}
                        name={'appointmentDate'}
                    >
                        <DatePicker showTime format={dateFormat}/>
                    </Form.Item>
                    <Form.Item
                        label={'Durum'}
                        name={'appointmentStatus'}

                    >
                        <AutoComplete>
                            {statuses.map(({value, text}) => {
                                return <Option key={value} value={text}>{text}</Option>
                            })}

                        </AutoComplete>
                    </Form.Item>

                </Form>

            </Modal>
        </React.Fragment>
    )
}
export default AppointmentEdit